<div class="flex justify-content-between">
  <p-button label="{{ 'Checkout.Cancel' | translate }}" styleClass="p-button-link-black p-button-sm  p-2" />
  <p-button label="{{ 'Checkout.Save_Draft_Exit' | translate }}"
    styleClass="p-button-link-black p-button-sm p-2" />
</div>
